import './index.scss'
// Vendor CSS for drag/resize builder
import 'react-grid-layout/css/styles.css'
import { createRoot } from 'react-dom/client'
import App from './App'
import { StrictMode, Suspense } from 'react'
import { LoadingComponent } from './components/ui/LoadingComponent'
// import { IconWaitOutline } from './components/icons/icon-components/IconWaitOutline'
import { LoaderSquares } from './components/ui/LoaderSquares'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <StrictMode>
    <Suspense
      fallback={
        // <div className="flex h-screen w-full items-center justify-center bg-grey-lightest">
        <div className="flex h-screen w-full items-center justify-center">
          {/* <LoadingComponent icon={<IconWaitOutline size={72} />} text="Please wait..." /> */}
          <LoadingComponent icon={<LoaderSquares />} text="Please wait..." />
        </div>
      }
    >
      <App />
    </Suspense>
  </StrictMode>
)
